import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl,getUserToken } from './index';

const dispatchRequestVerifyChangePhoneNumber = VerifychangePhoneNumber => ({
    type: ActionTypes.REQUEST_VERIFY_CHANGE_PHONE_NUMBER,
    VerifychangePhoneNumber
})

const dispatchReceivedVerifyChangePhoneNumber= res => ({
    type: ActionTypes.RECEIVED_VERIFY_CHANGE_PHONE_NUMBER,
    res
})

const dispatchErrorVerifyChangePhoneNumber = err => ({
    type: ActionTypes.ERROR_VERIFY_CHANGE_PHONE_NUMBER,
    err
})

const dispatchClearVerifyChangePhoneNumber = () => ({
    type: ActionTypes.CLEAR_VERIFY_CHANGE_PHONE_NUMBER
})

export const clearVerifyChangePhoneNumber = () => dispatchClearVerifyChangePhoneNumber();

export const  verifyChangePhoneNumber = (phoneNumber, otp) => dispatch =>{
        
    dispatch(dispatchRequestVerifyChangePhoneNumber(phoneNumber));

    const data = {
        phone: phoneNumber,
        user_otp: otp
    }

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/confirmphone`,
                data,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedVerifyChangePhoneNumber(data))
                })
        })
        .catch(e => dispatch(dispatchErrorVerifyChangePhoneNumber(e)));   
}
